import register from '../register';
import PlacesAutoComplete from './classes/places-autocomplete';

const $ = document.querySelector.bind( document );
const $$ = document.querySelectorAll.bind( document );

function sendAddressToDom( res ) {
  let fields = [
    'street_number',
    'street',
    'neighborhood',
    'borough',
    'city',
    'state',
    'country',
    'postal_code',
    'lat',
    'lng',
    'gis_id'
  ];

  fields.forEach( field => {
    const inputs = $$( `input[name=${ field }]` );
    Array.prototype.forEach.call( inputs, input => {
      input.value = res[ field ] ? res[ field ] : '';
    });
  });
}

function setFlow( flow ) {
  const inputs = $$('input[name="flow"]');
  Array.prototype.forEach.call( inputs, input => {
    input.value = flow;
  });
}

function showServiceableForm( bool, flow ) {
  const form = $('.check-serviceability__form-section');
  form.style.display = bool ? 'block' : 'none';
  showFormElement( true, flow );
}

function hideTop() {
  const el = $('.check-serviceability__top-section');
  el.classList.add('hidden');
}

function showSignup( place_id ) {
  const el = $('.check-serviceability__signup-available');
  const btn = $('.check-serviceability__signup-btn');
  btn.href = `${ window.signup_url }/signup/${ place_id }`;
  el.classList.remove('hidden');
}

function showServiceableHeader() {
  const headers = $$('.serviceable-form__title-section');
  headers.forEach( header => header.classList.add('hidden') );
  const header = $('.serviceable-form__title-section.is-serviceable');
  header.classList.remove('hidden');
}

function showNotServiceableHeader() {
  const headers = $$('.serviceable-form__title-section');
  headers.forEach( header => header.classList.add('hidden') );
  const header = $('.serviceable-form__title-section.not-serviceable');
  header.classList.remove('hidden');
}

function showWaitlist( place_id ) {
  const el = $('.check-serviceability__waitlist-available');
  const btn = $('.check-serviceability__waitlist-btn');
  btn.href = `${ window.signup_url }/waitlist/${ place_id }`;
  el.classList.remove('hidden');
}

function showFormElement( bool, flow ) {
  const section = $('.check-serviceability__form-section');

  // basic form and extended (w/ property manager info)
  const basic = section.querySelector('.serviceable__form');
  const ext   = section.querySelector('.serviceable__form-extended');

  const sms      = $('.serviceable-form__sms-disclaimer');
  const active   = flow === 'serviceable' ? ext : basic;
  const inactive = flow !== 'serviceable' ? ext : basic;

  active.style.display = bool ? 'block' : 'none';
  inactive.style.display = 'none';
  sms.style.display = !bool ? 'block' : 'none';
}

class ServiceableAutoComplete extends PlacesAutoComplete {
  onSelect( place ) {
    this._trackSelection( place, ( err, res ) => {
      res = res || {};
      console.log( res );

      if ( place.suggestion ) {
        // eslint-disable-next-line max-len
        { this.input.value = `${ place.suggestion.name }, ${ place.suggestion.locality }, ${ place.suggestion.state } ${ place.suggestion.postal_code }`; }
      }

      showServiceableForm( false );

      if ( window.acumen ) {
        window.acumen.track( `web-view-freeinternet_${ res.flow }` );
      }

      switch ( res.flow ) {
        case 'serviceable':
          showServiceableForm( true, res.flow );
          showServiceableHeader();
          sendAddressToDom( res );
          setFlow('freeinternet_serviceable');
          loadDrift();

          console.log('serviceable');
          break;
        case 'signup':
          hideTop();
          showSignup( res.place_id );
          console.log('signup');
          break;
        case 'waitlist':
        case 'paused':
          hideTop();
          showWaitlist( res.place_id );
          console.log('waitlist');
          break;
        case 'unknown':
          window.location.href = `${ window.signup_url }/register`;
          console.log('unknown');
          break;
        default:
          showServiceableForm( true, res.flow );
          showNotServiceableHeader();
          sendAddressToDom( res );
          setFlow('freeinternet_unserviceable');
          console.log('not serviceable');
      }
    });
  }
}

function loadDrift() {
  !function() {
    let t = window.driftt = window.drift = window.driftt || [];
    if ( !t.init ) {
      if ( t.invoked ) {
        return void (
          window.console &&
          console.error &&
          console.error('Drift snippet included twice.')
        );
      }
      t.invoked = !0;
      t.methods = [
        'identify',
        'config',
        'track',
        'reset',
        'debug',
        'show',
        'ping',
        'page',
        'hide',
        'off',
        'on'
      ];
      t.factory = function( e ) {
        return function() {
          let n = Array.prototype.slice.call( arguments );
          return n.unshift( e ), t.push( n ), t;
        };
      };
      t.methods.forEach( function( e ) {
        t[ e ] = t.factory( e );
      });
      t.load = function( t ) {
        let e = 3e5;
        let n = Math.ceil( new Date() / e ) * e;
        let o = document.createElement('script');

        o.type = 'text/javascript';
        o.async = !0;
        o.crossorigin = 'anonymous';
        o.src = 'https://js.driftt.com/include/' + n + '/' + t + '.js';

        let i = document.getElementsByTagName('script')[ 0 ];
        i.parentNode.insertBefore( o, i );
      };
    }
  }();

  window.drift.SNIPPET_VERSION = '0.3.1';
  window.drift.load('xt8yw9xw3h2z');

  window.drift.on( 'conversation:playbookFired', data => {
    console.log('PLAYBOOK EVENT FIRED');
    window.acumen.track( 'drift-playbook-fired', data );
  });
}

register( 'check-serviceability', () => {
  const component = document.querySelector('.check-serviceability-component');
  const input = component.querySelector('#check-availability-input');
  const list = component.querySelector('.results');
  new ServiceableAutoComplete({ input, list });
});

export default undefined;
